import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../../shared/user.service';
import { ErrorHandler } from '../../../../../shared/ErrorHandler';
import { Search } from '../../../../../shared/user.model';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-professional-tax-form',
  templateUrl: './professional-tax-form.component.html',
  styleUrls: ['./professional-tax-form.component.css']
})
export class ProfessionalTaxFormComponent implements OnInit {
  
  a: any =[];
  data: any=[];
  formInvalid: boolean;
  Id: number;
  mode: any;
  professionalTax: any =[];
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private titlecasePipe:TitleCasePipe) { }

  ngOnInit() {
   
    this.route.params.subscribe(params => {
      this.Id = params['id'];
      this.mode = params['mode'];       
      if(this.Id != null)  {       
        this.GetByIdprofessionalTax(this.Id);      
      } })
    
  this.GetAllProfessionalTax()
  }


  SaveProfessionalTax(Details){  
    
    if(Details.value.Pt_desc == null){
      return;
    }

    if (Details.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    
   else if(Details.value.To_amount< Details.value.From_amount){
      this.formInvalid = true;
          swal('Warning!', 'Invalid Taxable range', 'warning');
          return;
    }

    else {    
      //Details.value.ED_TYPE = 'E' ;
      this.data = this.userService.InsertProfessionalTax(Details.value);
      this.data.subscribe(
        (response) => {
          Details.reset();
          Details.resetForm();
          Details.form.markAsPristine();
          Details.form.markAsUntouched();
          swal('Success!', 'Professional Tax Added Successfully .', 'success');
          this.GetAllProfessionalTax()
          //this.router.navigate(['/home/payroll']);       
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }


  }


  UpdateProfessionalTax(Details){
    
    if (Details.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
     else if(Details.value.To_amount< Details.value.From_amount){
      this.formInvalid = true;
          swal('Warning!', 'Invalid Taxable range', 'warning');
          return;
    }

    else {    
      //Details.value.ED_TYPE = 'E' ;
      this.data = this.userService.updateProfessionalTax(Details.value, this.Id);
      this.data.subscribe(
        (response) => {
          Details.reset();
          Details.resetForm();
          Details.form.markAsPristine();
          Details.form.markAsUntouched();
          swal('Success!', 'Professional Tax Details Upadted Successfully .', 'success');
          this.GetAllProfessionalTax();
          //this.router.navigate(['/home/payroll']);       
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }


  }


  GetAllProfessionalTax(){
    //this.isSearch = false;   
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllProfessionalTax();
    this.data.subscribe(
         (response: any) => {
          this.professionalTax= response; 
          // if(this.allowedlist.length>0)   
          // this.totalItems= response[0].totalItems;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;   
                   
          document.getElementById('loader-spinner').style.display = "none";
         },    
          (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          }
      );      
  }


  GetByIdprofessionalTax(code) {   
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetProfessionalTaxById(code);
    this.data.subscribe(
      (response: any) => {
        this.a = response;
        //this.d.DEPND_DOB = ((this.d.DEPND_DOB).split('T'))[0];         
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  Cancel(){
    if(this.mode=='edit')
    this.router.navigate(['/home/payroll/payroll-compliance']);   
    else
      this.a=[];          
     
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/professional-tax/professional-tax-form/professional-tax-form.component.ts